<div class="section-currency section-topup p-3 bg-white">
  <h5
    class="section-wallet-heading.select-currency"
    i18n="@@wallet-topup-currency.select-currency"
  >
    STEP 1 : SELECT CURRENCY
  </h5>
  <p
    class="section-wallet-subheading mt-4"
    i18n="@@wallet-topup-currency.your-currency"
  >
    YOUR CURRENCIES:
  </p>
  <div class="user-currency-wrapper d-flex flex-wrap">
    @for (item of walletsCurrencies; track item) {
      <div
        class="user-currency-sec py-2 px-1 me-1"
        role="button"
        [ngClass]="{ active: walletTopUp?.currency == item.currency }"
        (click)="onSelectCurrency(item)"
      >
        <div
          class="currency-flag currency-flag-img-size"
          [ngClass]="'currency-flag-' + item.currency?.toLowerCase()"
        ></div>
        <p class="mt-2 mb-0 text-center">{{ item.currency }}</p>
      </div>
    }
  </div>
  <p
    class="section-wallet-subheading mt-4"
    i18n="@@wallet-topup-currency.add-new-currency"
  >
    OR ADD NEW CURRENCY :
  </p>
  <cai-select
    i18n-label="@@global.selectCurrency"
    placeholder="Select currency"
    [showTotal]="false"
    [options]="mappedExtraCurrencies"
    [showIcon]="false"
    [showCurrencyIcon]="true"
    [isReadOnly]="false"
    (onChangeOption)="onSelectCurrency($event)"
    [emitOptionChangeEvent]="true"
    [isReadOnly]="false"
    [maxDropdownHeight]="180"
    (onFocus)="onFocus.emit()"
    [alwaysFloat]="true"
    [customValue]="walletTopUp?.currency"
  >
  </cai-select>
</div>
